import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  visitCount: 0,
};

const visitSlice = createSlice({
  name: 'visit',
  initialState,
  reducers: {
    incrementVisit(state) {
      state.visitCount += 1;
    },
  },
});

export const { incrementVisit } = visitSlice.actions;
export default visitSlice.reducer;
